import { Autocomplete, AutocompleteOption, Chip, Icons, VariantProp } from '@healthinal/ui';
import { useGetLanguages } from '../../api/generated/locale-controller/locale-controller.ts';
import { LocaleDto } from '../../api/generated/model';

interface Props {
  onChange: (locale: LocaleDto[]) => void;
  value: LocaleDto[];
  variant?: VariantProp;
}
export function SelectLanguage({ onChange, value, variant }: Props) {
  const { data: languages, isPending } = useGetLanguages();

  return (
    <Autocomplete
      multiple
      value={value}
      onChange={(_, value) => onChange(value)}
      loading={isPending}
      options={languages ?? []}
      getOptionLabel={(option) => option.name}
      filterSelectedOptions
      getOptionKey={(option) => option.isoCode}
      isOptionEqualToValue={(option, value) => option.isoCode === value.isoCode}
      renderOption={(props, option) => (
        <AutocompleteOption {...props} key={option.isoCode}>
          {option.name}
        </AutocompleteOption>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip {...getTagProps({ index })} key={option.isoCode} endDecorator={<Icons.Close />}>
            {option.name}
          </Chip>
        ))
      }
      variant={variant}
    />
  );
}
